import { all, debounce, put, select, takeEvery } from 'redux-saga/effects';
import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { wasEveryActionLoadedSelector } from '@savgroup-front-common/core/domains/sagaRequestMetadata/selectors';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getModelByIdRequest } from '../../api/Catalog/getModelByIdQuery';
import { getModelByIdsRequest } from '../../api/Catalog/getModelByIdsCommand';
import { getModelsBySearchModelRequest } from '../../api/Catalog/getModelsBySearchModelQuery';
import { getRepairableByModelIdRequest } from '../../api/Catalog/getRepairableByModelId';

import {
  GET_MODEL_BY_ID,
  GET_MODEL_REPARABILITY,
  GET_MODELS_BY_SEARCH_MODEL_QUERY,
  LOAD_MODELS_INFO,
} from './actionTypes';

function* getModelByIdWorker({ payload: modelId }) {
  const meta = { modelId, indexer: modelId };

  const wasModelLoaded = yield select(wasEveryActionLoadedSelector, [
    { action: GET_MODEL_BY_ID, indexer: modelId },
  ]);

  if (wasModelLoaded || !modelId) {
    yield put(GET_MODEL_BY_ID.end(meta));

    return;
  }

  yield executeSagaRequest(
    GET_MODEL_BY_ID,
    getModelByIdRequest({ modelId }),
    meta,
  );
  yield put(GET_MODEL_BY_ID.end(meta));
}
export function* getModelByIdWatcher() {
  yield takeEvery(GET_MODEL_BY_ID.BASE, getModelByIdWorker);
}

function* getModelsBySearchModelQueryWorker({
  payload: { maxResult, sellerId = undefined, searchTerms },
}) {
  yield executeSagaRequest(
    GET_MODELS_BY_SEARCH_MODEL_QUERY,
    getModelsBySearchModelRequest({ maxResult, sellerId, searchTerms }),
    {
      sellerId,
      searchTerms,
      indexer: searchTerms,
    },
  );
  yield put(GET_MODELS_BY_SEARCH_MODEL_QUERY.end());
}
export function* getModelsBySearchModelQueryWatcher() {
  yield debounce(
    500,
    GET_MODELS_BY_SEARCH_MODEL_QUERY.BASE,
    getModelsBySearchModelQueryWorker,
  );
}

function* loadModelInfoWorker({ payload }) {
  yield executeSagaRequest(LOAD_MODELS_INFO, getModelByIdsRequest(payload));
  yield put(LOAD_MODELS_INFO.end());
}
export function* loadModelInfoWatcher() {
  yield takeEvery(LOAD_MODELS_INFO.BASE, loadModelInfoWorker);
}

function* getModelReparabilityWorker({ payload }) {
  const { modelId, sellerId } = payload;
  const meta = { modelId, indexer: modelId };

  yield executeSagaRequest(
    GET_MODEL_REPARABILITY,
    getRepairableByModelIdRequest({ id: modelId, sellerId }),
    meta,
  );
  yield put(GET_MODEL_REPARABILITY.end());
}
export function* getModelReparabilityWatcher() {
  yield takeEvery(GET_MODEL_REPARABILITY.BASE, getModelReparabilityWorker);
}

export default function* modelsSaga() {
  try {
    yield all([
      getModelsBySearchModelQueryWatcher(),

      getModelByIdWatcher(),
      loadModelInfoWatcher(),
      getModelReparabilityWatcher(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
